class SelectNavigationContact {
  constructor() {
    this.selects = document.querySelectorAll('[data-select-navigation-contact]');
    this.currentPath = window.location.pathname;
    this.urlParams = new URLSearchParams(window.location.search);

    if (this.selects.length === 0) return;

    this.init();
  }

  init() {
    // デフォルトでフォームブロックを非表示
    this.hideFormBlock();

    this.selects.forEach((select) => {
      this.setInitialSelection(select);
      this.attachEventListener(select);
    });
  }

  setInitialSelection(select) {
    const options = select.querySelectorAll('option[data-url]');
    // URLの末尾のslugを取得（/pages/slug形式を想定）
    const urlSlug = this.currentPath.split('/').filter(Boolean).pop();
    // URLパラメータからslugを取得（例: ?slug=contact-inquiry）
    const paramSlug = this.urlParams.get('slug');

    options.forEach((option) => {
      const optionUrl = option.dataset.url;
      const optionSlug = option.value;

      // URLのパス全体が一致、URLの末尾のslugが一致、またはパラメータのslugが一致
      if (optionUrl === this.currentPath || optionSlug === urlSlug || (paramSlug && optionSlug === paramSlug)) {
        option.selected = true;
        select.value = option.value;

        // is_direct=trueの場合はフォームビルダー要素を表示
        if (option.dataset.isDirect === 'true') {
          this.toggleFormBuilderElements(optionSlug);
        } else {
          // is_direct=falseの場合は説明を表示
          this.showDescription(select, option.dataset.description);
        }
      }
    });
  }

  attachEventListener(select) {
    select.addEventListener('change', (e) => {
      this.handleSelectChange(e.target);
    });
  }

  handleSelectChange(select) {
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption || !selectedOption.dataset.url) return;

    const isDirect = selectedOption.dataset.isDirect === 'true';
    const targetUrl = selectedOption.dataset.url;
    const description = selectedOption.dataset.description;
    const slug = selectedOption.value;

    // 現在のURLと一致する場合は何もしない
    if (targetUrl === this.currentPath) {
      // 説明をクリア
      this.clearDescription(select);
      return;
    }

    if (isDirect) {
      // is_direct=trueの場合は.globo-formbuilder内の該当要素を表示/非表示
      this.toggleFormBuilderElements(slug);
      this.clearDescription(select);
    } else {
      // is_direct=falseの場合は説明を表示し、すべてのフォームを非表示
      this.showDescription(select, description);
      this.hideAllFormBuilders();
    }
  }

  showDescription(select, description) {
    const container = select
      .closest('.page-contact__select-navigation-contact')
      .querySelector('[data-description-container]');
    if (container && description) {
      container.innerHTML = description;
      container.style.display = 'block';
    }
  }

  clearDescription(select) {
    const container = select
      .closest('.page-contact__select-navigation-contact')
      .querySelector('[data-description-container]');
    if (container) {
      container.innerHTML = '';
      container.style.display = 'none';
    }
  }

  toggleFormBuilderElements(targetSlug) {
    // すべての.globo-formbuilder要素を取得
    const formBuilders = document.querySelectorAll('.globo-formbuilder');

    if (formBuilders.length === 0) {
      // .globo-formbuilderが存在しない場合は.page-contact__form-blockを非表示
      this.hideFormBlock();
      return;
    }

    let hasMatch = false;

    formBuilders.forEach((formBuilder) => {
      // 該当するクラスを持つ.globo-formbuilder要素かチェック
      if (formBuilder.classList.contains(targetSlug)) {
        // 該当するクラスの要素からhiddenクラスを削除
        formBuilder.classList.remove('hidden');
        hasMatch = true;
      } else {
        // それ以外の要素にhiddenクラスを付与
        formBuilder.classList.add('hidden');
      }
    });

    // マッチする要素がない場合は.page-contact__form-blockを非表示
    if (!hasMatch) {
      this.hideFormBlock();
    } else {
      this.showFormBlock();
    }
  }

  hideAllFormBuilders() {
    // すべての.globo-formbuilder要素を非表示
    const formBuilders = document.querySelectorAll('.globo-formbuilder');

    formBuilders.forEach((formBuilder) => {
      formBuilder.classList.add('hidden');
    });

    // .page-contact__form-blockも非表示
    this.hideFormBlock();
  }

  hideFormBlock() {
    const formBlock = document.querySelector('.page-contact__form-block');
    if (formBlock) {
      formBlock.style.display = 'none';
    }
  }

  showFormBlock() {
    const formBlock = document.querySelector('.page-contact__form-block');
    if (formBlock) {
      formBlock.style.display = '';
    }
  }
}

// DOMContentLoadedで初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SelectNavigationContact();
  });
} else {
  new SelectNavigationContact();
}
